import { AppIcon } from '../Common/AppIcon';

import '../../styles/Animator.css';

import '../../styles/Channels.css';

export function Channels({ channels }) {
  return(
    <div className='columns is-desktop big-container'>
      {channels.links.map((link)=>(
        <div 
          key={link.service} 
          className='column icon-container tossing '
        >
          <a className="has-text-success" href={link.url} target="_blank">
            <AppIcon
              iconName={link.service}
            />
          </a>
        </div>
      ))}
    </div>
  );
}